export const environment = {
  production: false,
  apiUrl: 'https://dev-bdl-management.rindegastos.com', //DEV
  widgetSdkUrl: 'https://widget.rindegastos.com/rindegastos-widget.js',
  widgetOrigin: 'https://widget.rindegastos.com',
  //apiUrl: 'http://localhost:3000' // Local
};
